import "./Stages.css";
import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { stylesActions } from "../../../../store/Styles-slice";
import { useDispatch } from "react-redux";
import { useInView } from "react-intersection-observer";
import AOS from "aos";
import "aos/dist/aos.css";

const Stages = (props) => {
  const dispatch = useDispatch();
  const [hoveredCard, setHoveredCard] = useState(null);

  const { ref, inView } = useInView({
    threshold: 0.2,
  });

  useEffect(() => {
    if (inView) {
      dispatch(stylesActions.changeSectionName("Stages"));
    }
  }, [inView, dispatch]);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
    });
  }, []);

  // Stage icons mapping
  const stageIcons = {
    1: "📋",
    2: "📊",
    3: "✅",
    4: "🎯",
    5: "🎨",
    6: "⚡",
    7: "🔍",
    8: "🚀",
    9: "🛠️",
  };

  return (
    <Container className="!bg-[#1F1F1F] !relative !pb-10 !px-4 !overflow-hidden" fluid id="stages" ref={ref}>
      {/* Background decorative elements */}
      {/* <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute top-20 left-10 w-2 h-2 bg-[#FDCF00]/20 rounded-full animate-pulse"
          style={{ animationDelay: "0s" }}
        />
        <div
          className="absolute top-40 right-20 w-1 h-1 bg-[#FDCF00]/30 rounded-full animate-pulse"
          style={{ animationDelay: "2s" }}
        />
        <div
          className="absolute bottom-40 left-1/4 w-1.5 h-1.5 bg-[#FDCF00]/25 rounded-full animate-pulse"
          style={{ animationDelay: "4s" }}
        />
        <div
          className="absolute bottom-20 right-1/3 w-2 h-2 bg-[#FDCF00]/20 rounded-full animate-pulse"
          style={{ animationDelay: "1s" }}
        />
      </div> */}

      <Container className="!pt-10 !pb-6 !relative z-10">
        <Col data-aos="fade-up">
          {/* Header */}
          <Row className="!flex !items-center !justify-center !flex-col !mb-16">
            <div className="text-center">
              <div className="inline-block px-2 py-2 bg-[#FDCF00]/10 rounded-full mb-4">
                <span className="text-[#FDCF00] font-medium text-sm tracking-wider uppercase">
                  WE PREPARE YOUR PROJECTS IN {props.content?.length || 9} STAGES
                </span>
              </div>
            </div>
            <h2 className="text-4xl md:text-6xl font-bold text-white leading-tight text-center">
              Our Agile Development
              <br />
              <span className="text-[#FDCF00]">Approach</span>
            </h2>
            <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto text-center mt-4">
              A systematic approach to delivering exceptional digital solutions through proven methodologies and continuous collaboration.
            </p>
          </Row>

          {/* Process Flow */}
          <Row className="!relative !mt-6">
            {/* Connection lines */}
            <div className="absolute inset-0 pointer-events-none hidden lg:block">
              <svg className="w-full h-full" viewBox="0 0 1200 800" fill="none">
                <path
                  d="M200 150 Q400 100 600 150 T1000 150 M200 350 Q400 300 600 350 T1000 350 M200 550 Q400 500 600 550 T1000 550"
                  stroke="url(#gradient)"
                  strokeWidth="2"
                  strokeDasharray="5,5"
                  className="animate-pulse"
                />
                <defs>
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="transparent" />
                    <stop offset="50%" stopColor="#FDCF00" stopOpacity="0.5" />
                    <stop offset="100%" stopColor="transparent" />
                  </linearGradient>
                </defs>
              </svg>
            </div>

            {/* Cards Grid */}
            <div className="!m-auto !max-w-[1676px] !grid xs:!grid-cols-1 sm:!grid-cols-2 md:!grid-cols-2 lg:!grid-cols-3 xl:!grid-cols-3 xxl:!grid-cols-3 !gap-6 !place-items-center !w-full">
            {props.content?.map((stage, index) => (
              <div key={stage.id} className="!w-full !h-full">
                <div
                  className={`group relative bg-white/5 backdrop-blur-sm border-2 transition-all duration-500 cursor-pointer overflow-hidden rounded-xl h-full hover:scale-105 ${
                    hoveredCard === stage.id 
                      ? "border-[#FDCF00] scale-105" 
                      : "border-gray-700/50"
                  }`}
                  onMouseEnter={() => setHoveredCard(stage.id)}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-br from-[#FDCF00]/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                  {/* Content */}
                  <div className="relative p-6 space-y-4">
                    {/* Stage number and icon */}
                    <div className="flex items-center justify-between">
                      <div className="bg-[#FDCF00]/10 text-[#FDCF00]  border-[#FDCF00]/50 font-mono text-sm px-3 py-1 rounded-md">
                        {index + 1 < 10 ? `0${index + 1}` : index + 1}
                      </div>
                      <div className="text-2xl group-hover:scale-110 transition-transform duration-300">
                        {stageIcons[index + 1] || "📌"}
                      </div>
                    </div>

                    {/* Title */}
                    <h3 className="text-xl font-semibold text-white group-hover:text-[#FDCF00] transition-colors duration-300">
                      {stage.stage_name}
                    </h3>

                    {/* Description */}
                    <p className="text-gray-400 text-sm leading-relaxed">
                      {stage.brief_description || "Step-by-step process to ensure quality delivery."}
                    </p>

                    {/* Progress indicator */}
                    <div className="flex items-center space-x-2 pt-2">
                      <div className="flex-1 h-1 bg-gray-700 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-gradient-to-r from-[#FDCF00] to-[#FDCF00]/60 rounded-full transition-all duration-1000 ease-out"
                          style={{
                            width: hoveredCard === stage.id ? "100%" : "0%",
                            transitionDelay: hoveredCard === stage.id ? "200ms" : "0ms",
                          }}
                        />
                      </div>
                      <span className="text-xs text-gray-500 font-mono whitespace-nowrap">
                        {Math.round(((index + 1) / props.content?.length) * 100)}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            </div>
          </Row>
        </Col>
      </Container>
    </Container>
  );
};

export default Stages;
